import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_SET_IMAGE } from '../data/productImages';

/** Paste the live checkout URL here (platform not defined yet). */
const CHECKOUT_URL = '';
const included = ['6 volumes · 90 three-way activities', '5 instant-use bonuses', '300 landscape pages, print or phone', '15, 30 and 45-minute sessions + a 10-minute 1:1 visit', '48 planning worksheets', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-blush text-ink" data-id="element-190" data-mp="1rut1dpxhq02m">
      <div className="max-w-2xl mx-auto px-5 py-16 sm:py-20" data-id="element-191" data-mp="20teev6o3uowj">
        <div className="text-center" data-id="element-192" data-mp="20rtolt8tps4h">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-193" data-mp="3h74p6v5ti9em">
            Complete package
          </p>
          <h2 id="pricing-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-194" data-mp="3c7i9mf2ioh2n">
            Everything you need to run{' '}
            <span className="italic" data-id="element-195" data-mp="4s4bvc8hatif">every activity three ways</span>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-blush-dark bg-white shadow-card" data-id="element-196" data-mp="9ta3t7ubecqw">
          <div className="bg-plum px-5 py-5 text-center" data-id="element-197" data-mp="eqa7jc3oz3eu">
            <h3 className="font-display text-xl font-bold text-white sm:text-2xl" data-id="element-198" data-mp="3d8z0bmoj4bcz">
              Memory Care Activity Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-semibold text-gold-hover" data-id="element-199" data-mp="3i8boqbv1tqho">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-200" data-mp="3rxlidw5jjh7w">
            <img src={PRODUCT_SET_IMAGE} alt="All six Memory Care Activity Ready volumes side by side" width={1024} height={688} loading="lazy" className="mx-auto aspect-[1024/688] w-full max-w-lg rounded-2xl border border-cream-line object-cover" data-id="element-201" data-mp="3ryn3yuk6nm3v" />

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-202" data-mp="2mhrvlvtj7u6t">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-sm" data-id="element-203" data-mp="316o8q7ag3xea">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-gold/25" data-id="element-204" data-mp="318qxknzv3khf">
                    <CheckIcon className="h-3 w-3 text-gold-deep" aria-hidden="true" data-id="element-205" data-mp="28hqs08lvu8nn" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-cream-dark pt-6 text-center" data-id="element-206" data-mp="2ihhq0k9nj5sh">
              <div className="flex items-start justify-center gap-1 text-plum" data-id="element-207" data-mp="2dgai8l7ie6lt">
                <span className="mt-2.5 font-display text-3xl" data-id="element-208" data-mp="3tuk4n9s6xla0">$</span>
                <span className="font-display font-bold text-6xl leading-[0.9] sm:text-7xl" data-id="element-209" data-mp="3ow8vl19pzesu">
                  27
                </span>
                <span className="mt-3 text-[13px] font-semibold text-ink-muted" data-id="element-210" data-mp="9c6sd2ukqx2">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-211" data-mp="573zh9bbgh2b">
                <span className="rounded-full border border-gold bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-gold-ink" data-id="element-212" data-mp="3ngo24meaxqvw">
                  One-time payment
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-213" data-mp="j1n65wyam6qf">
                  No subscription
                </span>
                <span className="rounded-full border border-cream-dark px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-ink-soft" data-id="element-214" data-mp="a8b9zg4ufuco">
                  Instant download
                </span>
              </div>

              <CtaButton href={CHECKOUT_URL || '#pricing'} className="mt-5" data-id="element-215" data-mp="16qfup8cl5cb0">
                Get Memory Care Activity Ready — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-ink-soft" data-id="element-216" data-mp="3f8tny6iy92em">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-ink-soft" data-id="element-217" data-mp="359cldxyzv4mv">
                <li className="flex items-center gap-1.5" data-id="element-218" data-mp="31893l5xdyyj0">
                  <LockIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-219" data-mp="319u0h276atk1" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-220" data-mp="3t1043sm3r9e2">
                  <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-221" data-mp="3o75anxgp3g1s" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-222" data-mp="kk5az4v3x3d6">
                  <ShieldCheckIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-223" data-mp="fsevkkhbbpew" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-ink-soft" data-id="element-224" data-mp="23ehx3nw9t3es">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}